<template>
  <div class="w-full">
    <div class="flex justify-between items-center w-full">
      <div class="text-lg font-bold">
        Nastavenie dopravy
      </div>
      <!--      <Button @click="addNewDeliveryPlace" size="small" label="Pridať" icon="pi pi-plus" iconPos="right"/>-->
    </div>

    <hr class="my-4">

    <div v-if="loading">
      Načitavam...
    </div>

    <template v-else v-for="(_,i) in deliveryPlaces" :key="`${_?.id ?? i}-${i}`">
      <SingleDelivery v-model="deliveryPlaces[i]"
                      @delete-delivery-place="deleteDeliveryPlace"
                      @save-delivery-place="saveDeliveryPlace"
                      :index="i"
      />

      <hr v-if="i === 0" class="my-4">
    </template>

  </div>
</template>

<script setup>
import {nextTick, ref} from 'vue'
import {RESTAURANT_PLACES} from "@/content/lists.js"
import MySelect from "@/components/inputs/MySelect.vue";
import SingleDelivery from "@/components/views/SingleDelivery.vue";
import usePluStore from "@/stores/pluStore.js";
import Supabase from "@/utils/Supabase";

const pluStore = usePluStore()
const restaurantPlace = ref('BO')

const EMPTY_DELIVERY_PLACE = {
  name: '',
  variations: '',
  restaurantPlace: 'BO',
  minOrderAmount: '0',
  minOrderPrice: '0',
  pluItemId: null
}

const deliveryPlaces = ref([])

const addNewDeliveryPlace = () => {
  deliveryPlaces.value.unshift(EMPTY_DELIVERY_PLACE)
}

const deleteDeliveryPlace = async (id) => {
  if (!confirm('Uložiť zmeny?')) return
  const {data, error} = await Supabase.from('v2_Hajcer_App_DeliveryPlaces').delete().eq('id', id)
  if (error) {
    alert('Error deleting delivery place')
    return
  }
  await loadDeliveryPlaces()
}

const saveDeliveryPlace = async (saveData) => {

  saveData.minOrderPrice = Number(saveData.minOrderPrice)
  saveData.minOrderAmount = Number(saveData.minOrderAmount)
  saveData.variations = saveData.variations.split(',')

  const {data, error} = await Supabase.from('v2_Hajcer_App_DeliveryPlaces').upsert(saveData)
  if (error) {
    alert('Error saving delivery place')
    return
  }
  await loadDeliveryPlaces()
}

const loading = ref(false)
const loadDeliveryPlaces = async () => {
  deliveryPlaces.value = []
  loading.value = true
  const {data, error} = await Supabase.from('v2_Hajcer_App_DeliveryPlaces').select('*')
  loading.value = false
  if (error) {
    alert('Error loading delivery places')
    return
  }

  deliveryPlaces.value = data.map(item => ({
    ...item,
    variations: item.variations ? item.variations.join(', ') : ''
  }))

  deliveryPlaces.value.unshift({...EMPTY_DELIVERY_PLACE})
}

loadDeliveryPlaces()

</script>